import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'

import ViewerDocument from '../../../shared/components/ViewerDocument/ViewerDocument'
import usePolicyClient from '../../../clients/PolicyClient/usePolicyClient'

const TicketViewer = () => {
  const policyClient = usePolicyClient()
  const { billingId } = useParams()
  const history = useHistory()
  const params = new URLSearchParams(history.location.search)

  const numeroApolice = params.get('apolice')
  const numeroParcela = params.get('parcela')

  const [draftData, setDocumentData] = useState('')
  const [fileName, setFileName] = useState('boleto.pdf')

  useEffect(() => {
    const invoicePromise = policyClient().getInvoiceDocument({ billingId, base64: true })
    const policyPromise = policyClient().getDocumentPolicyInfo({ codigo: numeroApolice })
      .catch(() => null)

    Promise.all([invoicePromise, policyPromise])
      .then(([invoiceResponse, policyResponse]) => {
        setDocumentData(invoiceResponse.data)

        if (policyResponse?.data) {
          const { nomeSegurado, numeroApolice: numApolice } = policyResponse.data
          setFileName(`${nomeSegurado}_${numApolice}_${numeroParcela}.pdf`)
        } else {
          setFileName('download.pdf')
        }
      })
      .catch(() => {
        //
      })
  }, [billingId, numeroApolice, numeroParcela, policyClient])

  return (
    <>
      {draftData && (
        <ViewerDocument
          documentBase64={draftData}
          fileName={fileName}
        />
      )}
    </>
  )
}

export default TicketViewer
